import type { RegionCode } from '../graphql/api'

export const noPrefixRegion = 'UK' satisfies RegionCode

export const defaultRegion = 'INT' satisfies RegionCode

export type RoutingRegion =
    | Lowercase<Exclude<RegionCode, typeof noPrefixRegion>>
    | ''

export function getRoutingRegion(regionCode: RegionCode): RoutingRegion {
    if (noPrefixRegion === regionCode) {
        return ''
    }

    return regionCode.toLowerCase() as RoutingRegion
}
